<template>
  <div class="table">
    <table v-if="figures.includes(4.1) || figures.includes(4.3)" class="table-4">
      <tbody>
        <tr>
          <td></td>
          <td colspan="5" v-for="group in dataSource.groups" class="center-aligned">
            {{group}}
          </td>
        </tr>
        <tr style="height: 30px; vertical-align: top;">
          <td></td>
          <td v-for="(year, index) in dataSource.header" class="right-aligned" >{{index === 0 ? year : `\'${year.toString().slice(-2)}`}}</td>
        </tr>
        <tr v-for="row in dataSource.rows">
          <td v-bind:class="row.name.replace(' ', '-').toLowerCase()">
            {{row.name}}
          </td>
          <td v-for="data in row.data" class="right-aligned" v-bind:class="row.name.replace(' ', '-').toLowerCase()">
            {{data}}
          </td>
        </tr>
      </tbody>
    </table>
    <table v-if="figures.includes(6)" class="table-6">
      <tr>
        <td>Programmatic<br>Compliance Score</td>
        <td>Mortality Risk Ratio<br>(95% Confidence Interval)<br></td>
        <td>Immunologic Failure Risk<br>Ratio (95% CI)</td>
        <td>Virologic Failure Risk Ratio<br>(95% CI)</td>
      </tr>
      <tr>
        <td class="grey">0 (Best score)</td>
        <td class="grey">1 (–)</td>
        <td class="grey">1 (–)</td>
        <td class="grey">1 (–)</td>
      </tr>
      <tr>
        <td>1</td>
        <td>3.81 (1.73–8.42)</td>
        <td>1.39 (1.04–1.85)</td>
        <td>1.32 (1.05–1.67)</td>
      </tr>
      <tr>
        <td class="grey">2</td>
        <td class="grey">7.97 (3.70–17.18)</td>
        <td class="grey">2.17 (1.54–3.04)</td>
        <td class="grey">1.86 (1.46–2.38)</td>
      </tr>
      <tr>
        <td>3</td>
        <td>11.51 (5.28–25.08)</td>
        <td>2.93 (1.89–4.54)</td>
        <td>2.98 (2.16–4.11)</td>
      </tr>
      <tr>
        <td class="grey">4 or more<br>(Worst score)</td>
        <td class="grey">22.37 (10.46–47.84)</td>
        <td class="grey">9.71 (5.72–16.47)</td>
        <td class="grey">3.80 (2.52–5.73)</td>
      </tr>
    </table>
    <table v-if="figures.includes(9)" class="table-9" v-bind:style="{ minWidth: width + 'px' }">
      <tr>
        <td></td>
        <td></td>
        <td v-if="visibleFor('fha')" class="right-aligned bottom-aligned">Fraser</td>
        <td v-if="visibleFor('iha')" class="right-aligned bottom-aligned">Interior</td>
        <td v-if="visibleFor('viha')" class="right-aligned bottom-aligned">Island</td>
        <td v-if="visibleFor('nha')" class="right-aligned bottom-aligned">Northern</td>
        <td v-if="visibleFor('vcha')" class="right-aligned bottom-aligned">Vancouver<br>Coastal</td>
        <td v-if="visibleFor('bc')" class="right-aligned bottom-aligned">Total BC</td>
      </tr>
      <tr>
        <td class="grey">Age</td>
        <td class="grey">&lt; 30</td>
        <td v-if="visibleFor('fha')" class="grey right-aligned">{{dataSource['< 30'].fha}}</td>
        <td v-if="visibleFor('iha')" class="grey right-aligned">{{dataSource['< 30'].iha}}</td>
        <td v-if="visibleFor('viha')" class="grey right-aligned">{{dataSource['< 30'].viha}}</td>
        <td v-if="visibleFor('nha')" class="grey right-aligned">{{dataSource['< 30'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="grey right-aligned">{{dataSource['< 30'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="grey right-aligned">{{dataSource['< 30'].bc}}</td>
      </tr>
      <tr>
        <td></td>
        <td>30–39</td>
        <td v-if="visibleFor('fha')" class="right-aligned">{{dataSource['30–39'].fha}}</td>
        <td v-if="visibleFor('iha')" class="right-aligned">{{dataSource['30–39'].iha}}</td>
        <td v-if="visibleFor('viha')" class="right-aligned">{{dataSource['30–39'].viha}}</td>
        <td v-if="visibleFor('nha')" class="right-aligned">{{dataSource['30–39'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="right-aligned">{{dataSource['30–39'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="right-aligned">{{dataSource['30–39'].bc}}</td>
      </tr>
      <tr>
        <td class="grey"></td>
        <td class="grey">40–49</td>
        <td v-if="visibleFor('fha')" class="grey right-aligned">{{dataSource['40–49'].fha}}</td>
        <td v-if="visibleFor('iha')" class="grey right-aligned">{{dataSource['40–49'].iha}}</td>
        <td v-if="visibleFor('viha')" class="grey right-aligned">{{dataSource['40–49'].viha}}</td>
        <td v-if="visibleFor('nha')" class="grey right-aligned">{{dataSource['40–49'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="grey right-aligned">{{dataSource['40–49'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="grey right-aligned">{{dataSource['40–49'].bc}}</td>
      </tr>
      <tr>
        <td></td>
        <td>≥ 50</td>
        <td v-if="visibleFor('fha')" class="right-aligned">{{dataSource['≥ 50'].fha}}</td>
        <td v-if="visibleFor('iha')" class="right-aligned">{{dataSource['≥ 50'].iha}}</td>
        <td v-if="visibleFor('viha')" class="right-aligned">{{dataSource['≥ 50'].viha}}</td>
        <td v-if="visibleFor('nha')" class="right-aligned">{{dataSource['≥ 50'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="right-aligned">{{dataSource['≥ 50'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="right-aligned">{{dataSource['≥ 50'].bc}}</td>
      </tr>
      <tr>
        <td class="grey">Gender</td>
        <td class="grey">Male</td>
        <td v-if="visibleFor('fha')" class="grey right-aligned">{{dataSource['Male'].fha}}</td>
        <td v-if="visibleFor('iha')" class="grey right-aligned">{{dataSource['Male'].iha}}</td>
        <td v-if="visibleFor('viha')" class="grey right-aligned">{{dataSource['Male'].viha}}</td>
        <td v-if="visibleFor('nha')" class="grey right-aligned">{{dataSource['Male'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="grey right-aligned">{{dataSource['Male'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="grey right-aligned">{{dataSource['Male'].bc}}</td>
      </tr>
      <tr>
        <td></td>
        <td>Female</td>
        <td v-if="visibleFor('fha')" class="right-aligned">{{dataSource['Female'].fha}}</td>
        <td v-if="visibleFor('iha')" class="right-aligned">{{dataSource['Female'].iha}}</td>
        <td v-if="visibleFor('viha')" class="right-aligned">{{dataSource['Female'].viha}}</td>
        <td v-if="visibleFor('nha')" class="right-aligned">{{dataSource['Female'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="right-aligned">{{dataSource['Female'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="right-aligned">{{dataSource['Female'].bc}}</td>
      </tr>
      <tr>
        <td class="grey">Exposure</td>
        <td class="grey">MSM</td>
        <td v-if="visibleFor('fha')" class="grey right-aligned">{{dataSource['MSM'].fha}}</td>
        <td v-if="visibleFor('iha')" class="grey right-aligned">{{dataSource['MSM'].iha}}</td>
        <td v-if="visibleFor('viha')" class="grey right-aligned">{{dataSource['MSM'].viha}}</td>
        <td v-if="visibleFor('nha')" class="grey right-aligned">{{dataSource['MSM'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="grey right-aligned">{{dataSource['MSM'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="grey right-aligned">{{dataSource['MSM'].bc}}</td>
      </tr>
      <tr>
        <td></td>
        <td>PWID</td>
        <td v-if="visibleFor('fha')" class="right-aligned">{{dataSource['PWID'].fha}}</td>
        <td v-if="visibleFor('iha')" class="right-aligned">{{dataSource['PWID'].iha}}</td>
        <td v-if="visibleFor('viha')" class="right-aligned">{{dataSource['PWID'].viha}}</td>
        <td v-if="visibleFor('nha')" class="right-aligned">{{dataSource['PWID'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="right-aligned">{{dataSource['PWID'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="right-aligned">{{dataSource['PWID'].bc}}</td>
      </tr>
      <tr>
        <td class="grey">Total</td>
        <td class="grey"></td>
        <td v-if="visibleFor('fha')" class="grey right-aligned">{{dataSource['Total'].fha}}</td>
        <td v-if="visibleFor('iha')" class="grey right-aligned">{{dataSource['Total'].iha}}</td>
        <td v-if="visibleFor('viha')" class="grey right-aligned">{{dataSource['Total'].viha}}</td>
        <td v-if="visibleFor('nha')" class="grey right-aligned">{{dataSource['Total'].nha}}</td>
        <td v-if="visibleFor('vcha')" class="grey right-aligned">{{dataSource['Total'].vcha}}</td>
        <td v-if="visibleFor('bc')" class="grey right-aligned">{{dataSource['Total'].bc}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
  import { healthAuthorities } from './../../cli/constants';
  export default {
    props: [
      'figures'
    ],
    data() {
      let dataTable = null;
      let dataSource = {
        groups: [],
        header: [],
        rows: []
      };

      if (this.figures.includes(4.1) || this.figures.includes(4.3)) {
        for (const figure of this.figures) {
          dataTable = require(`./../../../temp/json/figure_${this.$route.params.ha}_${figure.toString().replace('.', '_')}.json`).instr.dataTable;
          for (const group of dataTable.groups) {
            dataSource.groups.push(group);
          }
          for (const header of dataTable.header) {
            dataSource.header.push(header);
          }
          if (dataSource.rows.length === 0) {
            for (const row of dataTable.rows) {
              dataSource.rows.push(row);
            }
          } else {
            for (const [index, row] of dataTable.rows.entries()) {
              for (const data of row.data) {
                dataSource.rows[index].data.push(data);
              }
            }
          }
        }
      }
      else if (this.figures.includes(9)) {
        dataSource ={};
        for (const ha in healthAuthorities) {
          if (healthAuthorities[ha]) {
            dataTable = require(`./../../../temp/json/figure_${ha}_9.json`).instr.dataTable;
            for (const group in dataTable) {
              if (dataTable[group]) {
                if (!dataSource[group]) {
                  dataSource[group] = {};
                }
                dataSource[group][ha] = dataTable[group];
              }
            }
          }
        }
      }

      return {
        dataSource,
        width: this.$route.params.ha === 'bc' ? 720 : 250,
      }
    },
    methods: {
      visibleFor: function(ha) {
        return ha === this.$route.params.ha || this.$route.params.ha === 'bc'
      }
    }
  }
</script>

<style scoped>
  .table td, .table th{
    border-top: 0px none;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .stage-0 {
    color: rgb(0, 118, 163);
  }
  .stage-1 {
    color: rgb(49, 140, 161);
  }
  .stage-2a {
    color: rgb(118, 106, 103);
  }
  .stage-2b {
    color: rgb(143, 70, 55);
  }
  .stage-3 {
    color: rgb(157, 7, 13);
  }

  table.table-4 {
    border-spacing: 0px;
    font-size: 11px;
  }

  .table-4 td {
    padding-left: 4px;
    padding-right: 4px;
  }

  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(2),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(3),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(5),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(6),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(7),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(8),
  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(9),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(6),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(11),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(21),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(26),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(31),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(36),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(41) {
    border-right: 1px solid black;
  }

  table.table-4 > tbody > tr:nth-child(1) > td:nth-child(5),
  table.table-4 > tbody > tr:nth-child(n+2) > td:nth-child(17)
   {
    border-left: 1px solid black;
  }

  table.table-6 {
    min-width: 720px;
    border-spacing: 0px;
  }

  table.table-9 {
    border-spacing: 0px;
  }

  .table-6 .grey,
  .table-9 .grey {
    background-color: #e6e7e9;
  }

  .table-6 td,
  .table-9 td {
    padding: 4px;
  }
</style>



// WEBPACK FOOTER //
// DataTable.vue?88b0703a